import type { VideoItem } from "../types";
import { PlayIcon } from "./icons";

export function VideoCard({
	item,
	onOpen,
}: {
	item: VideoItem;
	onOpen: (v: VideoItem) => void;
}) {
	return (
		<button className="video-card reveal" onClick={() => onOpen(item)}>
			<div className="video-card__thumb">
				<img src={item.poster} alt={item.label} loading="lazy" />
				<div className="video-card__play">
					<div className="video-card__play-btn">
						<PlayIcon />
					</div>
				</div>
			</div>
			<div className="video-card__tag">{item.tag}</div>
			<div className="video-card__label">{item.label}</div>
			{item.meta && (
				<div className="video-card__meta">
					<span>{item.meta}</span>
				</div>
			)}
		</button>
	);
}
